import { render, staticRenderFns } from "./Name.vue?vue&type=template&id=07207a9c&scoped=true&"
import script from "./Name.vue?vue&type=script&lang=js&"
export * from "./Name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07207a9c",
  null
  
)

export default component.exports